export const SpQuery = {
  all: '全て',
  without: 'SP以外',
  only: 'SPのみ'
} as const;

export type SpQueryKey = keyof typeof SpQuery;

export const SpQueryKeys: readonly SpQueryKey[] = ['all', 'without', 'only'];
